import moment from 'moment-timezone';

function values(x, y) {
    if (x > y) {
        return 1;
    }

    if (x < y) {
        return -1;
    }

    return 0;
}

function dates(x, y) {
    return values(moment(x).valueOf(), moment(y).valueOf());
}

export default {
    values,
    dates,
};
